import axios from "axios";
import Localbase from "localbase";
import { createApp } from "vue";
import VueAxios from "vue-axios";
import VueCookies from 'vue-cookies';
import GAuth from "vue3-google-oauth2";
import VueGtag from "vue-gtag";
import App from "./App.vue";
import { GOOGLE_CLIENT_ID, GOOGLE_TAG } from "./config";
import myMixin from "./mixins/";
import router from "./router";
import store from "./store";

const gAuthOptions = {
  clientId: GOOGLE_CLIENT_ID,
  scope: "email",
  prompt: "consent",
  fetch_basic_profile: false,
};
let db = new Localbase("db");
db.config.debug = false;

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.config.globalProperties.$localBase = db;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

const token = localStorage.getItem("Appoen");

if (token) {
  axios.defaults.headers.common["Authorization"] = token;
} else {
  localStorage.clear();
}

app.use(VueCookies)
app.use(store);
app.use(router);
app.use(VueGtag, {
  config: { id: GOOGLE_TAG },
}, router);
app.use(VueAxios, axios);
app.use(GAuth, gAuthOptions);
app.mixin(myMixin);

app.mount("#app");
